export const GUARANTEE_KEY = 'guarantee'

export const guaranteeQueryKeys = {
  all: [GUARANTEE_KEY] as const,
  lists: () => [...guaranteeQueryKeys.all, 'list'] as const,
  list: (params: { transitOperationId: number | null }) => [...guaranteeQueryKeys.lists(), params] as const,
}
